<template>
  <section>
    <ul class="voucher-list">
      <li
        v-for="(partnerVoucher, index) in voucherList"
        :key="'partner_voucher_' + index"
      >
        <button @click="voucherPurchase(partnerVoucher)" class="voucher-item">
          <div class="label-area">
            <h3>
              <span>{{ getValueFn(partnerVoucher, 'product_name') }}</span>
              <span
                v-if="isDiscountRate(partnerVoucher)"
                class="icon icon-supplant"
                >{{ getValueFn(partnerVoucher, 'discount_rate') }}%</span
              >
            </h3>
            <div class="price-area">
              <span
                v-if="getValueFn(partnerVoucher, 'displayamount') !== ''"
                class="before-price"
                >&#65510;{{
                  setNumberCommasFn(getValueFn(partnerVoucher, 'displayamount'))
                }}</span
              >
              <button
                type="button"
                :class="
                  getValueFn(selectedVoucher, 'product_name') ===
                  getValueFn(partnerVoucher, 'product_name')
                    ? 'btn selected'
                    : 'btn'
                "
                @click="voucherPurchase(partnerVoucher)"
              >
                &#65510;{{
                  setNumberCommasFn(getValueFn(partnerVoucher, 'amount'))
                }}
              </button>
            </div>
          </div>
          <table class="benefit-table">
            <caption>
              웨이브 이용권 표
            </caption>
            <colgroup>
              <col style="width: 80px" />
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">동시시청</th>
                <td>{{ getValueFn(partnerVoucher, 'concurrency') }}</td>
              </tr>
              <tr>
                <th scope="row">화질</th>
                <td>{{ getValueFn(partnerVoucher, 'quality') }}</td>
              </tr>
              <tr>
                <th scope="row">이용기기</th>
                <td>{{ getValueFn(partnerVoucher, 'support_device') }}</td>
              </tr>
            </tbody>
          </table>
        </button>
      </li>
    </ul>

    <div class="common-benefit">
      <h4>이용권 공통 혜택</h4>
      <ul class="common-benefit-list">
        <li
          v-for="(item, index) in VOUCHER_COMMON_BENEFITS"
          :key="`common_benefits__${index}`"
        >
          <span v-html="item"></span>
        </li>
      </ul>
    </div>
  </section>
</template>
<script setup>
  import { defineProps, ref } from 'vue'
  import { VOUCHER_COMMON_BENEFITS } from '@/components/voucher/voucher-text/const'

  const props = defineProps({
    voucherPurchaseFn: {
      type: Function,
      default: () => {},
    },
    voucherList: {
      type: Array,
      default: () => [],
    },
    getValueFn: {
      type: Function,
      default: () => {},
    },
    setNumberCommasFn: {
      type: Function,
      default: () => {},
    },
  })

  const selectedVoucher = ref({})

  const isDiscountRate = (voucherInfo) => {
    const discountRate = voucherInfo?.concurrency?.[0]?.discount_rate ?? ''
    return discountRate !== ''
  }

  const voucherPurchase = (voucher) => {
    selectedVoucher.value = voucher
    props.voucherPurchaseFn(voucher)
  }
</script>
<style lang="scss" src="@/assets/scss/category/ticket.scss"></style>
<style scoped lang="scss">
  @import '@/assets/scss/import/_mixin.scss';
  @import '@/assets/scss/import/_color.scss';
  .voucher-item {
    &:hover,
    &.selected {
      .btn {
        background-color: $white;
        color: $neutral-10;
      }
    }
  }
</style>
